import { buildImageUrl, BASE_URL } from "../helper/constants";
import { loadedImagesCache } from "./imageLoadCache";
import {
  isBlobOrDataUrl,
  isHttpUrl,
  lookupPendingBlob,
} from "./pendingOutgoingMedia";

function firstUrl(value) {
  if (!value) return "";
  if (Array.isArray(value)) return value[0] ? String(value[0]) : "";
  return String(value);
}

export function resolveGalleryImage(img, chatId, extraKeys = []) {
  const raw = firstUrl(img?.fileUrl);
  const serverFromField = firstUrl(img?.serverFileUrl);
  const pendingBlob = lookupPendingBlob(img, chatId, extraKeys);
  const blob = isBlobOrDataUrl(raw) ? raw : pendingBlob;
  const http = isHttpUrl(raw) ? raw : (isHttpUrl(serverFromField) ? serverFromField : "");
  let built = "";
  try {
    built = buildImageUrl(!!(img?.local || blob), blob || raw, img?.attachedFileName);
  } catch (e) {
    built = blob || raw;
  }
  if (http && loadedImagesCache.has(http)) {
    return { url: http, fallbackUrl: blob || "", serverUrl: http };
  }
  if (blob) {
    return { url: blob, fallbackUrl: blob, serverUrl: http };
  }
  if (http) {
    return { url: http, fallbackUrl: "", serverUrl: http };
  }
  if (built && !built.startsWith("http") && !isBlobOrDataUrl(built) && built.length) {
    return { url: BASE_URL + built, fallbackUrl: "", serverUrl: "" };
  }
  return { url: built || raw, fallbackUrl: "", serverUrl: http };
}
